<div class="row">
    <nav class="navbar navbar-pimeo full-width">
        <div class="col-12 text-center">
            <a [routerLink]="'/home'">
                <img
                    class="navbar-brand-home"
                    src="{{ navService.menu.companyLogo }}"
                />
            </a>
            <h3>{{ navService.menu.clientName }}</h3>
        </div>
    </nav>
    <div class="col-12">
        <h4>{{ navService.menu.title }}</h4>
        <router-outlet class="sm-pad-none"></router-outlet>
    </div>
</div>
